var state = {
  qrState: null
};
var getters = {
  qrState: function qrState(state) {
    return state.qrState;
  }
};
var mutations = {
  QR_STATE: function QR_STATE(state, qrState) {
    state.qrState = qrState;
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref) {
    var commit = _ref.commit;
    commit('TOGGLE_SIDEBAR');
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};